import { TspType } from '@entities/tsp'
import { Payee } from '@root/api/ump-catalog-manager'

export const getDisplayedPayees = (payees: Payee[]) =>
  payees.reduce((acc, payee) => {
    payee?.features?.category_web?.split(', ').forEach((category) => {
      if (payee.features?.platform_type !== 'business' && Object.values(TspType).includes(category as TspType)) {
        acc[category] = acc[category] || []
        acc[category].push(payee)
      }
    })

    return acc
  }, {}) as Record<TspType, Payee[]>
